import React from 'react';

const AllianceTreasury = () => {
  return <h1>AllianceTreasury Page</h1>;
};

export default AllianceTreasury;
